export default __webpack_public_path__ + "static/media/staff-terry-grainger.6d4f1ea5.jpg";